import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem("adminToken");
    // const isAuthenticated = true;

    if (!isAuthenticated) {
        // redirect to login page if not logged in
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
